<form (ngSubmit)="submit()" novalidate [formGroup]="form" autocomplete="off">
  <ion-grid style="padding: 2.5px 5px 0 5px;">
    <ion-row>
      <ion-col style="padding: 0;">
        <div class="custom-form-group">
          <input formControlName="firstname" (ionChange)="submit()" id="firstname" class="form-control" type="text"  placeholder="" required>
          <label for="firstname">{{ 'Checkout.Form.FirstName' | translate }}<span style="color:red;">*</span></label>
          @if (formFieldValidatorSubmit('firstname', 'required')) {
            <span style="padding-bottom: 2px;"class="form-errors"
            >{{ 'Checkout.FormErrors.FirstNameRequired' | translate}}</span>
          }
        </div>
      </ion-col>
      <ion-col style="padding: 0;">
        <div class="custom-form-group">
          <input formControlName="lastname" (ionChange)="submit()" id="lastname" class="form-control" type="text"  placeholder="" required>
          <label for="lastname">{{ 'Checkout.Form.LastName' | translate }}<span style="color:red;">*</span></label>
          @if (formFieldValidatorSubmit('lastname', 'required')) {
            <span style="padding-bottom: 2px;"class="form-errors"
            >{{ 'Checkout.FormErrors.LastNameRequired' | translate}}</span>
          }
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col style="padding: 0;">
        <div class="custom-form-group">
          <input formControlName="email" (ionChange)="submit()" id="email" class="form-control" type="text"  placeholder="" required>
          <label for="email">{{ 'Checkout.Form.Email' | translate }}<span style="color:red;">*</span></label>
          @if (formFieldValidatorSubmit('email', 'email')) {
            <span style="padding-bottom: 2px;"class="form-errors"
            >{{'Checkout.FormErrors.EmailInvalid' | translate}}</span>
          }
          @if (formFieldValidatorSubmit('email', 'required')) {
            <span style="padding-bottom: 2px;"class="form-errors"
            >{{'Checkout.FormErrors.EmailRequired' | translate}}</span>
          }
        </div>
      </ion-col>
      <ion-col style="padding: 0;">
        <div class="custom-form-group">
          <input formControlName="phone" (ionChange)="submit()" id="phone" class="form-control" type="text"  placeholder="" required>
          <label for="phone">{{ 'Checkout.Form.PhoneNumber' | translate }}<span style="color:red;">*</span></label>
          @if (formFieldValidatorSubmit('phone', 'required')) {
            <span style="padding-bottom: 2px;"class="form-errors"
            >{{ 'Checkout.FormErrors.PhoneNumberRequired' | translate}}</span>
          }
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>